import { TFunction } from 'react-i18next';
import { ContactDetailsModel } from '../../models/customerDetails';
import { CustomerDataVisibleFields } from '../../types';

export const getFullNameLabel = (
  t: TFunction<'customer-details'[]>,
  firstName?: string,
  lastName?: string
) => {
  if (firstName && lastName) {
    return t('contact_details.full_name');
  }
  if (firstName) {
    return t('contact_details.first_name');
  }
  if (lastName) {
    return t('contact_details.last_name');
  }
  return null;
};

export const getFullName = (firstName?: string, lastName?: string) => {
  if (!firstName && !lastName) {
    return null;
  }
  return `${firstName || ''} ${lastName || ''}`.trim();
};
export const getVisibleContactDetailsFields = (
  contactDetails: ContactDetailsModel,
  visibleFields: CustomerDataVisibleFields
): Partial<ContactDetailsModel> =>
  (Object.keys(contactDetails) as Array<keyof ContactDetailsModel>)
    .filter((field) => visibleFields.includes(field))
    .reduce((acc, field: keyof ContactDetailsModel) => {
      return {
        ...acc,
        [field]: contactDetails[field],
      };
    }, {} as Partial<ContactDetailsModel>);
